module.exports = __webpack_public_path__ + "static/empty-states-value-props-sample-content-dont-4bd9ebc651ea6c5631de7f4ea5b76c2f.png";